/* eslint-disable no-use-before-define */
import {css} from '@emotion/core'
import {mediaQueries} from '../../twd/twd'

export const sectionCss = css`
    background-color: #ffffff;
    ${mediaQueries.notXs} {
        padding: 0 20px;
    }

    .table {
        border-bottom: 0px;
    }
}    
`

export const textAlignRight = css`
    ${mediaQueries.notXs} { text-align: right }
`

export const backgroundColor= css`
    ${mediaQueries.notXs} { background-color: #f6f6f6; }
`
